import { render, staticRenderFns } from "./PhoneModal.vue?vue&type=template&id=be1e8944&scoped=true&"
import script from "./PhoneModal.vue?vue&type=script&lang=js&"
export * from "./PhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneModal.vue?vue&type=style&index=0&id=be1e8944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1e8944",
  null
  
)

export default component.exports